import {
  YesOrNoFlug,
  Prefectures,
  FacilityKbn,
  FacilityKind,
} from "../../../assets/data/Constants";
import { TkGetCode } from "../../../utils/TkGetCode";

function funFacilityInfoBodyList(res: any) {
  const facilityInfoBodyList = res.facilityList?.map((item: any) => [
    {
      children: (item.facilityNo ?? "") + ":" + (item.facilityName ?? ""), //施設名称
      forSort: item.facilityNo,
    },
    {
      children: item.requestDate, //開設年月日
      forSort: item.requestDate,
      align: "center",
    },
    {
      //施設住所
      children: (
        <>
          〒{item.zipcode}
          <br />
          {TkGetCode(Prefectures, item.prefectureCd ?? "")}
          {item.addressCity}
          {item.addressOthers}
        </>
      ),
      forSort: item.zipcode,
    },
    {
      children: FacilityKind[item.facilityKind as keyof typeof FacilityKind], // 施設種類
      forSort: item.facilityKind,
    },
    {
      children: TkGetCode(FacilityKbn, item.facilityKbn), // 施設区分
      forSort: item.facilityKbn,
    },
    {
      children:
        !item.specifiedStaffNum && !item.hcStaffNum
          ? "-"
          : (item.specifiedStaffNum ?? 0) + (item.hcStaffNum ?? 0) + "人", // 特定職員数等
      forSort: (item.specifiedStaffNum ?? 0) + (item.hcStaffNum ?? 0),
      align: "right",
    },
    {
      children: TkGetCode(YesOrNoFlug, item.notificationOfNonParticipationFlg), // 非加入届
      forSort: item.notificationOfNonParticipationFlg,
      align: "center",
    },
    {
      children: TkGetCode(YesOrNoFlug, item.partialCancellationFlg), // 部分解除
      forSort: item.partialCancellationFlg,
      align: "center",
    },
    {
      //担当者情報
      children: (
        <>
          {item.managerName}
          <br />
          {item.tel}
          <br />
          {item.managerEmail}
        </>
      ),
      forSort: item.managerName,
    },
  ]);

  return facilityInfoBodyList ?? [];
}

export { funFacilityInfoBodyList };
